import Stack from '@mui/material/Stack';

import { CoffeeBreak } from '../../Illustrations/CoffeeBreak';
import { InfoAlert } from '../../InfoAlert';

// TODO : avertissement si doc plus recent que derniere version
// TODO : drawer pour choisir les destinataires

export const ShareTabPanel = () => (
  <Stack sx={{ width: '100%' }}>
    <InfoAlert sx={{ mb: 2 }}>
      Cette fonctionnalité est visible dans l&apos;édition des modèles
      uniquement à des fins de développement et de test. À terme, elle sera
      uniquement disponible dans l&apos;éditeur des documents.
    </InfoAlert>
    <CoffeeBreak />
  </Stack>
);
